import { c as _c } from "react/compiler-runtime";
import { ReactNode } from "react";
import useDeviceInfo from "@/hooks/useDeviceInfo";
import useIsMobileScreen from "@/hooks/isMobileScreen";
import AppLayout from "./AppLayout";
import SmallScreenLayout from "./SmallScreenLayout";
interface MobileLayoutProps {
  readonly children: ReactNode;
}
const MobileLayout = t0 => {
  const $ = _c(6);
  const {
    children
  } = t0;
  const {
    isApp
  } = useDeviceInfo();
  const isSmallScreen = useIsMobileScreen();
  if (isApp) {
    let t1;
    if ($[0] !== children) {
      t1 = <AppLayout>{children}</AppLayout>;
      $[0] = children;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  if (isSmallScreen) {
    let t1;
    if ($[2] !== children) {
      t1 = <SmallScreenLayout>{children}</SmallScreenLayout>;
      $[2] = children;
      $[3] = t1;
    } else {
      t1 = $[3];
    }
    return t1;
  }
  let t1;
  if ($[4] !== children) {
    t1 = <>{children}</>;
    $[4] = children;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
};
export default MobileLayout;